/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireCmdbErrorAnalytics } from '@jira/servicedesk__insight-common-utils-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { performCmdbPutRequest } from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import { getCmdbConfigStatusTypeByIdUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getCmdbConfigReferenceTypeUrl.tsx';
import type { CategoryType } from '@jira/servicedesk__insight-common-shared/src/CategoryType.types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { StatusTypeResponse, ActionApi } from './ActionApi.types.tsx';

export type StatusTypeProperties = {
	name?: string;
	displayName?: string;
	description?: string;
	category?: CategoryType;
};

export type RequestBodyType = {
	statusTypeId: string;
	updatedProperties: StatusTypeProperties;
};

export const setStatusType =
	(updatedStatusType: StatusTypeResponse): ActionApi =>
	async ({ setState, getState }) => {
		const state = getState();
		const updatedData = state.statusTypes.data?.map((statusType) =>
			statusType.id === updatedStatusType.id ? updatedStatusType : statusType,
		);

		setState({
			...state,
			statusTypes: { ...state.statusTypes, data: updatedData },
		});
	};

export const updateStatusType =
	({ statusTypeId, updatedProperties }: RequestBodyType): ActionApi =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		const state = getState();

		setState({
			...state,
			statusTypes: { ...state.statusTypes, updateLoading: true },
		});

		try {
			const response = await performCmdbPutRequest(
				getCmdbConfigStatusTypeByIdUrl(workspaceId, statusTypeId),
				{ body: JSON.stringify(updatedProperties) },
			);
			const updatedState = getState();
			let merged: StatusTypeResponse = response;
			if (fg('cdm_display_name')) {
				const displayNameMerged =
					response.displayName !== undefined ? response.displayName : updatedProperties.displayName;
				merged = {
					...response,
					...(displayNameMerged !== undefined ? { displayName: displayNameMerged } : {}),
				};
			}
			const updatedData = updatedState.statusTypes.data?.map((statusType) =>
				statusType.id === response.id ? merged : statusType,
			);

			setState({
				...updatedState,
				statusTypes: {
					...updatedState.statusTypes,
					updateLoading: false,
					data: updatedData || undefined,
				},
			});

			fireTrackAnalytics(createAnalyticsEvent({}), 'updateStatusType succeeded');
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			const updatedState = getState();

			setState({
				...updatedState,
				statusTypes: {
					...updatedState.statusTypes,
					updateLoading: false,
					updateError: error,
				},
			});

			fireCmdbErrorAnalytics({
				meta: {
					id: 'updateStatusType',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
					teamName: 'astral',
				},
				error,
			});

			throw error;
		}
	};
